import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconUserFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconUserFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'cb82924d4ecd2398083d4901d3c1298902db1036', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '381d446fe417d9805f7f2dae30ec3a6e18a46c8a', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '557236ce68bfc5bce02e3ec2236aa9548abe90ab', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 3.5a3.8 3.8 0 0 1 2.9 1.191c.693.8.99 1.871.805 2.914l-.268 2.306A3.35 3.35 0 0 1 11 13a3.35 3.35 0 0 1-3.436-3.09l-.272-2.324a3.5 3.5 0 0 1 .81-2.897A3.8 3.8 0 0 1 11 3.5M8.47 14.064a5.49 5.49 0 0 0 5.072 0 .5.5 0 0 1 .416-.033 6.115 6.115 0 0 1 4.047 5.44.504.504 0 0 1-.505.529H4.512a.504.504 0 0 1-.505-.53 6.115 6.115 0 0 1 4.047-5.44.5.5 0 0 1 .416.034", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-user-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-user-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-user-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconUserFilled$1);
            }
            break;
    } });
}

const CosmosIconUserFilled = CosmosIconUserFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconUserFilled, defineCustomElement };
